<template>
  <el-dialog title="修改卡资源" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" width="500px">
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="卡片选择" prop="baseResourcesId">
        <el-select v-model="form.baseResourcesId" style="width: 240px;" placeholder="请选择卡片">
          <el-option v-for="item in this.cardBaseResources" :value="item.id" :key="item.id" :label="item.merCardName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="核卡" prop="nuclearCardAmount"><el-input placeholder="请输入核卡" v-model="form.nuclearCardAmount" type="number" style="width: 240px;"></el-input></el-form-item>
      <el-form-item label="首刷" prop="firstPayAmount"><el-input placeholder="请输入首刷" v-model="form.firstPayAmount" type="number" style="width: 240px;"></el-input></el-form-item>
      <el-form-item label="结算周期" prop="settlementDays"><el-input placeholder="请输入结算周期" v-model="form.settlementDays" type="number" style="width: 240px;"></el-input> 天</el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import CardResourcesApi from '@/api/cardresources.js';
  export default {
    components: {
    },
    data() {
      return {
        form: {
          id: null,
          baseResourcesId: null,
          nuclearCardAmount: null,
          firstPayAmount: null,
          settlementDays: null
        },
        /*卡基础资源列表*/
        cardBaseResources:[],
        filePath: '',
        formRules: {
          baseResourcesId: [{
            required: true,
            message: '请选择卡片',
            trigger: 'blur'
          }],
          nuclearCardAmount: [{
            required: true,
            message: '请输入核卡',
            trigger: 'blur'
          }],
          firstPayAmount: [{
            required: true,
            message: '请输入首刷',
            trigger: 'blur'
          }],
          settlementDays: [{
            required: true,
            message: '请输入结算周期',
            trigger: 'blur'
          }],
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
      };
    },
    props: ['open', 'editform'],
    watch: {
      open: function(n, o) {
        let self = this;
        self.form.id = self.editform.id;
        self.form.baseResourcesId = self.editform.baseResourcesId;
        self.form.nuclearCardAmount = self.editform.nuclearCardAmount;
        self.form.firstPayAmount = self.editform.firstPayAmount;
        self.form.settlementDays = self.editform.settlementDays;
        if (n != o) {
          this.dialogVisible = this.open;
        }
      }
    },
    created() {
      /*获取下拉列表*/
      this.getCardBaseResourcesList();
    },

    methods: {
      /*修改*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = self.form;
        if (!self.isInteger(params.settlementDays)){
          this.$message.error('结算周期必须为整数');
          self.loading = false;
          return false;
        }
        CardResourcesApi.amend(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，修改成功',
              type: 'success'
            });
            self.dialogFormVisible(true);
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*获取下拉列表*/
      getCardBaseResourcesList() {
        let self = this;
        CardResourcesApi.cardBaseResourcesSelectList({}, true)
          .then(res => {
            self.cardBaseResources = res.data;
          })
          .catch(error => {
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      },

      isInteger(obj) {
        return obj%1 === 0
      }
    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/cardapply/cardresources/dialog/Edit.vue